import { debounce } from "lodash";
import React, { useState, useCallback } from "react";
import { AssistantSettingsProp } from "./Models";
import { Dropdown, Option } from "@fluentui/react-components";
import { SearchFindColleague } from "@/components/ui/Search/SearchFindColleague";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { RootState } from "@/redux";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { OrganizationEntity, SettingService } from "@/services";

const emailsFlow = [
  {
    Value: "0",
    Text: "Only primary organizer",
  },
  {
    Value: "1",
    Text: "Only assistant organizer",
  },
  {
    Value: "2",
    Text: "Primary AND assistant organizer",
  },
];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AssistantSettings: React.FC<AssistantSettingsProp> = (props) => {
  const orgStore: IOrganizationStore = useSelector(
    (state: RootState) => state.orgInfo
  ) as IOrganizationStore;

  const [value, setValue] = useState<string>("");
  const [emailFlow, setEmailFlow] = useState<string>("0");

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      setValue(value);
    }, 500),
    []
  );

  const handleChange = (newValue: string) => {
    debouncedSearch(newValue);
  };

  const assistantQuery = useQuery<OrganizationEntity[] | []>({
    queryKey: ["organization", value],
    queryFn: () => onFetchData(value),
    staleTime: 20 * 1000,
    enabled: !!value,
  });

  console.log("🚀 ~ assistantQuery:", assistantQuery);

  const onFetchData = async (
    keyword: string | undefined
  ): Promise<OrganizationEntity[] | []> => {
    if (keyword) {
      const settingServiceImpl: SettingService = new SettingService();

      const request: any = {
        tenantId: orgStore.orgInfo?.tenantId || "",
        orgId: orgStore?.orgInfo?.guid || "",
      };
      const response = await settingServiceImpl.fetchOrganization(
        request,
        value
      );
      return response.data;
    }
    return [];
  };

  return (
    <div className="rf-settings-content rf-settings-content-assistant">
      <div className="rf-settings-content-row">
        <SearchFindColleague
          currentUser={{
            Email: "",
            DisplayName: "",
          }}
          listData={[]}
          onChange={(value) => {
            handleChange(value);
          }}
          onSelect={() => {}}
          defaultAssistant={""}
          placeholder={"Enter a part of the name to search for"}
        />
      </div>
      <div className="rf-settings-content-row">
        <div className="rf-settings-content-row-title">Email flow</div>

        <div className="rf-settings-content-row-details">
          <Dropdown
            className="wapper-language"
            placeholder="Please select an option"
            onOptionSelect={(e: any, d: any) => {
              setEmailFlow(d?.optionValue);
            }}
            selectedOptions={[emailFlow?.toString()]}
            defaultValue={emailsFlow?.find((item) => item.Value === emailFlow)?.Text || undefined}
            // value={emailsFlow?.find((item) => item.Value === emailFlow)?.Text || undefined}
          >
            {emailsFlow.map((t) => {
              return (
                <Option key={t.Value} value={t.Value} onClick={() => {}}>
                  {t.Text}
                </Option>
              );
            })}
          </Dropdown>
        </div>
      </div>
      <div className="rf-settings-content-row-footer">
        <div
          className={`rf-settings-button ${!true ? "disable-btn" : ""}`}
          title={"Apply"}
          tabIndex={3}
        >
          Apply
        </div>
      </div>
    </div>
  );
};
